import { useMemo } from 'react';
import { useListInsurersQuery } from '../../../../../../api/queries/listInsurers';

const useInsurerOptions = (companyId: string) => {
    const { data, loading } = useListInsurersQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            pagination: null,
            filter: { companyId },
        },
    });

    return useMemo(() => {
        const insurerList = data?.list?.items.map(insurer => ({
            label: insurer.displayName,
            value: insurer.id,
        }));

        return { insurerList, loading };
    }, [data?.list?.items, loading]);
};

export default useInsurerOptions;
